import React, { useState } from 'react'
import CreateTemplateStep from './CreateTemplateStep'
import SelectTemplateStep from './SelectTemplateStep'

export default function TemplateStep({
  currentTemplate,
  configSections,
  setConfigSections,
  onBack,
  onNext,
  onClose,
  handleTemplateChange,
  editing,
  closeAllOtherModals,
  defaultReportSections,
  defaultTemplate,
  organization,
}) {
  const [templateStep, setTemplateStep] = useState(0)

  const templateSteps = [SelectTemplateStep, CreateTemplateStep]
  const StepComponent = templateSteps[templateStep]

  const handleBack = () => {
    if (templateStep === 0) {
      onBack()
    } else {
      setTemplateStep(templateStep - 1)
    }
  }

  return (
    <StepComponent
      currentTemplate={currentTemplate}
      configSections={configSections}
      setConfigSections={setConfigSections}
      onBack={handleBack}
      onClose={onClose}
      onNext={onNext}
      setTemplateStep={setTemplateStep}
      handleTemplateChange={handleTemplateChange}
      editing={editing}
      closeAllOtherModals={closeAllOtherModals}
      defaultReportSections={defaultReportSections}
      defaultTemplate={defaultTemplate}
      organization={organization}
    />
  )
}
